export const saveAnalysisFormProgress = (
  folderId: string,
  values: object,
): void => {
  localStorage.setItem(
    `analysisFormProgress-${folderId}`,
    JSON.stringify(values),
  );
};

export const removeAnalysisFormProgress = (folderId: string): void => {
  localStorage.removeItem(`analysisFormProgress-${folderId}`);
};

export const getAnalysisFormProgress = (folderId: string): object => {
  const progress = localStorage.getItem(`analysisFormProgress-${folderId}`);
  return progress ? JSON.parse(progress) : {};
};
